import { Controller } from "@hotwired/stimulus"
import componentOptions from "../src/shopify-buy-button-config"

// Connects to data-controller="shopify-product"
export default class extends Controller {
  static targets = ["component"]
  static values = {
    id: String
  }

  connect() {
    window.shopifyUi.createComponent('product', {
      id: this.idValue,
      node: this.componentTarget,
      moneyFormat: '%24%7B%7Bamount%7D%7D',
      options: componentOptions(),
    });
  }
}
